module.exports = __webpack_public_path__ + "resources/img/main04_jp.b13beb856a3d8279ceaa9376c2ce900e.jpg";